class TotalPage {
  constructor(private readonly _value: number = 1) {
  }

  get value() {
    return this._value;
  }
}

export default TotalPage;
